import _ from 'lodash'
import {COMPONENT_FEATURES} from '@wix/format-converter-schemas'
import type {ComponentFeature} from '@wix/document-services-types'

/**
 * Get a feature's value from an element, checking both query and alias property names
 * Returns the value and which property name was found
 */
export const getFeatureValue = (
    element: Record<string, unknown>,
    feature: ComponentFeature
): {value: unknown; propertyName: string} | null => {
    const {query, alias} = feature
    if (query in element) {
        return {value: element[query], propertyName: query}
    }
    if (alias in element) {
        return {value: element[alias], propertyName: alias}
    }
    return null
}

/**
 * Get a feature's value as a plain object, checking both query and alias property names
 * Returns null if the value is not a plain object
 */
export const getFeatureObjectValue = (
    element: Record<string, unknown>,
    feature: ComponentFeature
): {value: Record<string, unknown>; propertyName: string} | null => {
    const result = getFeatureValue(element, feature)
    if (result && _.isPlainObject(result.value)) {
        return {value: result.value as Record<string, unknown>, propertyName: result.propertyName}
    }
    return null
}

// Export commonly used features for convenience
export const DATA_FEATURE = COMPONENT_FEATURES.data
export const INNER_ELEMENTS_FEATURE = COMPONENT_FEATURES.innerElements
